module.exports = "<span class=\"checkbox-text js-display-text\">{{title}}</span>\n<span class=\"checkbox-group js-checkbox-group_conianer\"></span>\n";